import { FirstLoginForm } from "@/components/auth/first-login-form"
export function FirstLoginPage() {
  return <FirstLoginForm />
}
